export function getHourAndMinuteByTime(minutes: number) {
    const hour = Math.floor(minutes / 60)
    let minute = minutes % 60

    const minuteFormatted = minute < 10 ? minute.toString().padStart(2, '0') : minute.toString()

    return [hour, minuteFormatted]
}